// extracted by mini-css-extract-plugin
export default {"action-btn":"HealthDenialTwo--action-btn--t+mQK","actionBtn":"HealthDenialTwo--action-btn--t+mQK"};